import './AllActivities.css';

import React, { Component } from 'react';
import { Grid, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';



class AllActivities extends Component {
    render() {
        const { scene } = this.props;
        return (
            <div>
            
            </div>
        )
    }
}

AllActivities.propTypes = {
    scene: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    scene: state.scene.current
});

export default connect(
    mapStateToProps
)(AllActivities);



// WEBPACK FOOTER //
// ./src/components/allActivities/AllActivities.js